module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.regularMedicines && _vm.regularMedicines.length <= 0) ? _c('div', {
    staticClass: "portlet box green"
  }, [_c('div', {
    staticClass: "portlet-title"
  }, [_c('div', {
    staticClass: "caption"
  }, [_c('i', {
    staticClass: "fa fa-heartbeat",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Medicação programada")])])]), _vm._v(" "), _c('div', {
    staticClass: "portlet-body tasks-widget"
  }, [_c('p', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    staticClass: "text-center m-b-0"
  }, [_vm._v("Não há medicação programada para o aluno(a) cadastrada pelos responsáveis.")])])]) : _vm._e(), _vm._v(" "), (_vm.regularMedicines && _vm.regularMedicines.length) ? _c('div', {
    staticClass: "portlet box green"
  }, [_c('div', {
    staticClass: "portlet-title"
  }, [_c('div', {
    staticClass: "caption"
  }, [_c('i', {
    staticClass: "fa fa-heartbeat",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Medicação programada")])]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "portlet-body tasks-widget"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped table-condensed flip-content"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.regularMedicines), function(medicine, index) {
    return _c('tr', {
      staticClass: "font-grey-cascade"
    }, [(medicine.isTaken == 1) ? _c('td', [_c('i', {
      staticClass: "fa fa-check font-green",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v("  Ministrada")]) : _vm._e(), _vm._v(" "), (medicine.isTaken == 0 && _vm.getTimeDiff(medicine.time) > 0) ? _c('td', [_c('i', {
      staticClass: "fa fa-exclamation-triangle font-red",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v("  Atrasada - " + _vm._s(_vm._f("date")(medicine.time, 'HH:mm', true)))]) : _vm._e(), _vm._v(" "), (medicine.isTaken == 0 && _vm.getTimeDiff(medicine.time) <= 0) ? _c('td', [_c('i', {
      staticClass: "fa fa-calendar-minus-o",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v("  Programada para " + _vm._s(_vm._f("date")(medicine.time, 'HH:mm', true)))]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v(_vm._s(medicine.medicine) + " - " + _vm._s(medicine.dosage))])])
  }))])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "actions"
  }, [_c('a', {
    staticClass: "btn btn-circle btn-default",
    attrs: {
      "href": "#/medicine"
    }
  }, [_c('i', {
    staticClass: "fa fa-heartbeat"
  }), _vm._v("\n\t\t\t\tIr para Medicações\n\t\t\t")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v("Medicação - Dosagem")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-558d00a4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./sources/domains/agenda/health/scheduled-medicine/scheduled-medicine.vue
// module id = 1071
// module chunks = 1